import type {PermissionsRecordType} from '../permissions';

/** Stored calls (`CALL` resource): reading them, linking them to records, listening to them. */
export const callPermissions = {
  callRead: {
    actionId: 'READ',
    resourceId: 'CALL',
    scopes: [],
  },
  callAssignRecord: {
    actionId: 'ASSIGN_RECORD',
    resourceId: 'CALL',
    scopes: [],
  },
  callUnassignRecord: {
    actionId: 'UNASSIGN_RECORD',
    resourceId: 'CALL',
    scopes: [],
  },
  callUpdateNote: {
    actionId: 'UPDATE_NOTE',
    resourceId: 'CALL',
    scopes: [],
  },
  /** Explicit grant: listening to recordings is not part of reading calls. */
  callListenRecording: {
    actionId: 'LISTEN_RECORDING',
    resourceId: 'CALL',
    scopes: [],
  },
} satisfies PermissionsRecordType;
